import { useNavigate } from "react-router";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER } from "../../../constants/routes";
import { DiscoveryPreOrderFilterBar } from "./components/DiscoveryPreOrderFilterBar";
import { DiscoveryV2PreOrderList } from "./DiscoveryV2PreOrderList";

export const DiscoveryV2PreOrders = () => {
  const navigate = useNavigate();

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"Supplier Pre-Orders"}
      />
      <div className="m-auto flex w-[100vw] max-w-[1200px] flex-col gap-4 p-4 transition-opacity min-[640px]:w-[88vw] min-[1280px]:w-[79vw] md:pt-10">
        <div className="flex flex-col rounded-lg bg-white p-4">
          <DiscoveryPreOrderFilterBar />
        </div>
        <DiscoveryV2PreOrderList />
      </div>
    </>
  );
};
